<template>
  <main class="APP-contents">
    <div class="front-wrapper">
      <div class="circle-left"></div>
      <div class="circle-right"></div>
      <div class="front relative">
        <div class="margin-vert-40px medium-margin-vert-100px">
          <div class="container">
            <div class="margin-vert-50px">
              <div class="margin-vert-20px medium-margin-vert-35px">
                <div class="provider">
                  <img
                    class="img-responsive center-block"
                    v-bind:src="`${publicPath}static/img/pages/index/provider.png`"
                  />
                </div>
              </div>
              <div class="medium-margin-vert-30px">
                <div class="identity">
                  <img
                    class="img-responsive center-block"
                    v-bind:src="`${publicPath}static/img/pages/index/keyvisual.png`"
                  />
                </div>
              </div>
            </div>
            <div class="medium-margin-vert-30px">
              <div class="desc">
                <p
                  class="text-demi-small large-text-medium"
                >みらいの自分診断は、のべ37万人のデータを基に心理学と統計学をベースにした「怖いほど当たる」性格診断で話題の診断コンテンツです。簡単な質問に答えるだけで、あなたの性格とそこから予想される、みらいの働き方をお伝えします。</p>
              </div>
            </div>
            <div class="margin-vert-15px medium-margin-vert-30px text-center">
              <router-link to="/question" class="start-button" >
                診断START
                <span class="start-button__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                    <title>arrow right</title>
                    <polyline
                      points="78.75 29.5 177.25 128 78.75 226.5"
                      fill="none"
                      stroke="#000"
                      stroke-miterlimit="10"
                      stroke-width="30"
                    />
                  </svg>
                </span>
              </router-link>

            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// @ is an alias to /src
export default {
  name: "index",
  data() {
    return {
      publicPath: process.env.BASE_URL,
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/_var/_variables.scss";
@import "@/assets/css/_mixin/_breakpoints.scss";
@import "@/assets/css/pages/index.scss";
</style>